import { useEffect } from 'react';

const useScopedCss = (cssFilePath) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssFilePath;

    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, [cssFilePath]);
};

export default useScopedCss;
